import PmsPromptConfigPage from './PmsPromptConfigPage';

export default PmsPromptConfigPage;